import { debounce  } from 'throttle-debounce';

export default class GlobalSearch {
    config = {
        header: null,
        container: null,
        form: null,
        action: null,
        active_facet: '',
        search_facet: null,
        search_input: null,
        search_input_placeholder: null,
        search_clear: null,
        search_results: null,
        search_suggestion: null,
        query: null,
        buttonOpen: null,
        buttonClose: null,
        endpoint: null,
        body: null,
        delay: 500,
        template: `<li><a class="result {{className}}" href="{{link}}" target="_self">
                        <span class="text">{{text}}</span>
                        <span class="type">{{type}}</span>
                    </a></li>`
    }

    constructor(header)
    {
        // Check if header exists
        this.config.header = header;

        if(header){
            // Mark up variables
            this.config.container                   = this.config.header.find('.header-search-overlay');
            this.config.form                        = this.config.container.find('form.search-form');
            this.config.action                      = this.config.form.attr('action');
            this.config.search_facet                = this.config.container.find('.header-search-overlay__facets > li > a');
            this.config.search_input                = this.config.container.find('input[type="search"]');
            this.config.search_input_placeholder    = $(this.config.search_input).attr('placeholder');
            this.config.search_clear                = this.config.container.find('.search-clear');
            this.config.buttonOpen                  = this.config.header.find('[data-header-search-open]');
            this.config.buttonClose                 = this.config.container.find('.header-search-overlay__close');

            this.config.form.append(`<ul class="search-results"></ul>`);

            this.config.search_results  = this.config.container.find('.search-results');

            // Init Header Search Overlay Functionality
            this.init();
        }

        // Search query variables
        this.config.endpoint        = `${siteData.globalServer}wp-json/mimas/v1/search/elastic` ?? null;
    }

    init()
    {
        // Set top offset for overlay
        this.setHeaderHeight();
        // Add event handlers for search overlay
        this.eventHandlers();

        $(window).on('resize', debounce(this.config.delay, () => {
            this.setHeaderHeight();
        }));
    }

    setHeaderHeight()
    {
        let $wpAdminBar         = $('#wpadminbar');
        let $header             = $(this.config.header).find('.header__container');
        let topOverlayOffset    = ($wpAdminBar.length) ? $wpAdminBar.outerHeight() + $header.outerHeight() : $header.outerHeight();

        this.config.container.css('--top-overlay-offset', topOverlayOffset + 'px');
    }

    eventHandlers()
    {

        let _t = this;

        // Click Behaviours for Search Facets Tabs
        $(_t.config.search_facet).on('click', debounce(this.config.delay, function() {
            if(!$(this).hasClass('active')){
                $('.header-search-overlay__facets > li > a.active').removeClass('active');
                
                $(this).addClass('active');

                _t.config.active_facet = $(this).data('facet');

                let query              = $(_t.config.search_input).val();
                let facet              = (_t.config.active_facet.length > 0) ? _t.config.active_facet.toLowerCase() : '';
                let placeholder        = (facet) ? 'Find ' + facet : _t.config.search_input_placeholder;

                // Change form action query
                _t.config.form.attr('action', _t.config.action + '/' + facet);

                // Change search input text
                _t.config.search_input.attr('placeholder', placeholder);
            
                // Check if search input isn't empty
                if(query.trim().length > 0){
                    _t.config.query = query;
                    _t.getSearchResults();
                };
            }
        }));

        $(_t.config.form).on('submit', function(e){
            e.preventDefault();

            let query = $(_t.config.search_input).val();

            // Check if search input isnt empty and the search query doesn't match the previous query
            if (query.trim().length > 0) $(this)[0].submit();
        });

        // Typing Behaviours for Search Input
        $(_t.config.search_input).on('keyup', debounce(this.config.delay, function() {
           let query = $(this).val();

           _t.config.search_results.hide();
            
           // Check if search input isnt empty and the search query doesn't match the previous query
            if(query.trim().length > 0  && _t.config.query !== query){
                _t.config.query = query;
                _t.config.search_clear.addClass('active');
                _t.getSearchResults();
            } else {
                _t.config.query = '';
                _t.config.search_clear.removeClass('active');
            }
        }));

        // Search Dropdown Behaviour When Typing and Clicking In Search Input
        $(_t.config.search_input).on('click', function() {            
            let query = $(this).val();

            $(_t.config.search_results).show();

            // Empty search results if the query is empty and there's existing results
            if(query.trim().length > 0 && _t.config.search_results.children().length > 0 && !_t.config.search_clear.hasClass('active')) _t.config.search_clear.addClass('active');

            if(query.trim().length === 0 && _t.config.search_results.children().length > 0) _t.config.search_results.empty();
        });

        // Click Behaviour Outside of Search Dropdown and Search Imput
        $(document).on('click', function(e) {
            let $target = $(e.target);

            if (!$target.is(_t.config.search_input) && !$target.closest(_t.config.search_results).length) {
                $(_t.config.search_results).hide();
            }
        });

        // Update Search Input Query When Suggested Text Clicked
        $(document).on('click', '.header-search-overlay a.result', function(e) {
            e.preventDefault();

            let query = ($(this).hasClass('suggestion')) ? $(this).find('.highlight').text() : $(this).find('.text').text();
            let facet = $(this).find('.type').text();

            $(_t.config.search_input).val(query);
            $(_t.config.search_results).hide();

            _t.config.active_facet = facet;

            facet = (_t.config.active_facet.length > 0) ? _t.config.active_facet.toLowerCase() : '';

            // Change form action query
            _t.config.form.attr('action', _t.config.action + '/' + facet);
            
            $(_t.config.form)[0].submit();
        });

        // Clear Search Input and Results
        $(_t.config.search_clear).on('click', function() {
            $(this).removeClass('active');

            $(_t.config.search_results).hide();
            $(_t.config.search_results).empty();
            $(_t.config.search_input).val('');

            _t.config.query = '';
        });
    }

    // Fetches Data From WP Query Endpoint /wp-json/mimas/v1/elastic
    fetchAPI(endpoint, params = {}) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: Object.keys(params).length 
                    ? `${endpoint}?${$.param(params)}`
                    : endpoint,
                method: 'GET',
                beforeSend: () => {
                    this.config.form.addClass('loading');
                },
                complete: () => {
                    this.config.form.removeClass('loading');
                },
                success: (response) => {
                    resolve(response);
                },
                error: (err) => {
                    reject(err);
                }
            });
        });
    }

    cleanSearchTitle($title){
        $title.replace(/<[^>]*>/g, ' ') // Remove HTML tags (like <br />, <p>, etc.)
              .replace(/&[#\w]+;/g, ' ') // Remove HTML entities
              .replace(/[^\w\s-]/g, ' ') // Remove special characters except dash
              .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
              .trim();

        return $title;
    }

    // Renders the HTML for the Search Suggestion Item (Did you mean?)
    renderSearchSuggestion(suggestion)
    {
        let _t = this;

        let html = this.config.template
            .replaceAll('{{className}}', 'suggestion' || '')
            .replaceAll('{{link}}', '#' || '')
            .replaceAll('{{text}}', 'Did you mean <div class="highlight">' + suggestion + '</div>' || '')
            .replaceAll('{{type}}', 'Suggestion');

        let $resultItem = $(html);

        _t.config.search_results.append($resultItem);
    }

    // Renders the HTML for the Search No Results Item
    renderSearchNoResults()
    {
        let _t = this;

        let html = this.config.template
            .replaceAll('{{className}}', 'no-results' || '')
            .replaceAll('{{link}}', '#' || '')
            .replaceAll('{{text}}', 'We couldn\'t find any results for <div class="highlight">' + _t.config.query + '</div>' || '')
            .replaceAll('{{type}}', 'No results');

        let $resultItem = $(html);

       _t.config.search_results.append($resultItem);
    }

    // Render Search Results For Different Result Types
    renderSearchResults(results)
    {
        let _t = this;

        $.each(results, (index, result) => {
            let text    = _t.cleanSearchTitle(result.highlight.search_as_you_type[0]) ?? '';
            let type    = result._source.search_tab ?? '';

            let html = _t.config.template
                .replaceAll('{{className}}', type.toLowerCase())
                .replaceAll('{{link}}', '#' || '')
                .replaceAll('{{text}}', text)
                .replaceAll('{{type}}', type);

            _t.config.search_results.append(html);
        });
    }

    // Generates Query For 
    generateSearchBody()
    {
        return {
            'query': this.config.query,
            'facet': this.config.active_facet
        }
    }

    // Generates the Search Body (Params) and hits the WordPress Rest EndPoint
    getSearchResults()
    {
        let _t              = this;
        _t.config.body      = _t.generateSearchBody();

        _t.fetchAPI(this.config.endpoint, this.config.body)
        .then(response => {
            _t.config.search_results.empty();
            _t.config.search_results.show();

            // Check if response has no suggestion and no results
            if(response.suggest.did_you_mean[0].options.length == 0 && response.hits.hits.length == 0) _t.renderSearchNoResults();

            // Check if response has a suggestion
            if(response.suggest.did_you_mean[0].options.length > 0) _t.renderSearchSuggestion(response.suggest.did_you_mean[0].options[0].text);

            // Check if response has results
            if(response.hits.hits.length > 0) _t.renderSearchResults(response.hits.hits);
        })
        .catch(err => {
            console.log(err);
        });
    }
}

$(document).ready(function () {
    if($('.header-search-overlay').length) new GlobalSearch($('header'));
});